module.exports = __webpack_public_path__ + "static/media/card_IBAN.ebbc106e.png";